import styled from 'styled-components'
import {
  alignItems,
  border,
  borderColor,
  borderRadius,
  bottom,
  color,
  flexDirection,
  flexWrap,
  fontSize,
  fontWeight,
  height,
  justifyContent,
  left,
  maxWidth,
  right,
  space,
  top,
  width,
  zIndex,
} from 'styled-system'
import {
  createShouldForwardProp,
  props as styledSystemProps,
} from '@styled-system/should-forward-prop'

const STYLE_FNS = {
  alignItems,
  borderColor,
  borderRadius,
  borders: border,
  bottom,
  color,
  flexDirection,
  flexWrap,
  fontSize,
  fontWeight,
  height,
  justifyContent,
  left,
  maxWidth,
  right,
  space,
  top,
  width,
  zIndex,
}

const toStyleFn = (value) => {
  if (typeof value === 'function') return value
  if (value && typeof value === 'object') return () => value
  if (typeof value === 'string') return STYLE_FNS[value] || null
  return null
}

const withDefaultAttrs = (Component, attrs) => {
  const attrFactory = (props) => {
    const resolved = {}
    Object.entries(attrs).forEach(([key, value]) => {
      resolved[key] = typeof value === 'function' ? value(props) : value
    })
    return resolved
  }

  return styled(Component).attrs(attrFactory)``
}

const system = (config = {}, ...args) => {
  const { extend = 'div', blacklist = [], css, ...attrs } = config
  const styleFns = [css, ...args].map(toStyleFn).filter(Boolean)
  const shouldForwardProp = createShouldForwardProp([
    ...styledSystemProps,
    ...blacklist,
  ])

  const Base = Object.keys(attrs).length
    ? withDefaultAttrs(extend, attrs)
    : extend

  return styled(Base).withConfig({ shouldForwardProp })`
    ${styleFns}
  `
}

export default system
